import tw, { styled } from 'twin.macro';

const Embed = styled.div`
  ${tw`w-full relative pt-8`};
  height: ${({ height }) => height > 0 && `${height}px`};
  width: ${({ width }) => width > 0 && `${width}%`};
  ${({ disabled }) =>
    disabled &&
    `
    pointer-events: none;
    `}

  & #iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    inset: 0;
    border: none;
  }
`;

export default Embed;
